/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import {Card, CardContent, CardActions, CardMedia, Button, Divider} from '@mui/material'
import styled from 'styled-components'
import BackgroundImage from '../assets/images/background.jpg'
import { LoadingOverlay } from '../components/common'
import { toast } from 'react-toastify'
import ReCAPTCHA from "react-google-recaptcha"
import { AppContext } from '../stores/AppStore'
import { UserContext } from '../stores/UserStore'

const Background = styled.div`
  background: url(${BackgroundImage}) no-repeat center center fixed;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.background };
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.gray};
`

const ContentText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.gray};
  text-align: justify;
  width: 100%;
`
const Request = (props) => {
  const history = useHistory()
  const { logo } = useContext(AppContext)
  const { applications, app, loadApp, requestAccess, getCurrentUserInfo } = useContext(UserContext)
  const [isLoading, setIsLoading] = useState(false)
  const [captChar, setCaptChar] = useState(null)
  const [requestUser, setRequestUser] = useState(null)

  useEffect(() => {
    if (applications) {
      loadApp().then().catch(error => {
        history.replace('/select-app')
      })
    } 
  }, [applications])     

  useEffect(() => {
    if (app) {
        getCurrentUserInfo().then(userInfo => {
          setRequestUser(userInfo.username)
        }).catch(error => {
          toast.error('Cannot load user') 
          history.replace('/logout?app='+app.id)
        })
    } 
  }, [app])

  const onCaptcharChange = (value) => {
    if (!requestUser) {
      toast.error('Cannot load user') 
      history.replace('/logout?app='+app.id)
    } else {
      setCaptChar(value)
    }  
  }

  const onCaptcharExpired = () => {
    setCaptChar(null)
  }

  const onGoToLogin = () => {
    setIsLoading(true)
    history.replace('/logout?app='+app.id)        
  }

  const onConfirm = () => {
    setIsLoading(true)
    const data = {userId: requestUser, applicationId: app.id} 
    requestAccess(data, captChar).then(() => {
      toast.success('User request success! An email has been sent to ' + app.label + ' to accept your request.')
      //setIsLoading(false)
      history.replace('/logout?app='+app.id)
    }).catch(errorMessage => {
      setCaptChar(null)
      setIsLoading(false)
      console.error(errorMessage)
      if (errorMessage === 'INVALID_CAPTCHAR') {
        toast.error('Invalid CAPTCHAR! Please try again.')
      } else {
        toast.error(errorMessage)
      }
    })        
  }

  const renderBackground = useMemo(() => <Background>
    <Card sx={{ width:'30vw', height:'45vh', padding:'10px', display: 'flex', flexDirection: 'column', justifyContent:'stretch', alignItems:'stretch' }}>
      <CardContent>
        <CardMedia image={logo} component="img" sx={{ width: '10vw', marginBottom: '40px' }} title="Logo..."/>
        {/* <Typography variant="h5" color="textSecondary" component="h2" sx={{ marginBottom: '5vh'}}>Access denied!</Typography> */}
        <ContentText>
        <p>You don't have access to the <b>{app && app.label}</b> application.</p>
        <p>If you want to request one please click on "Send request".</p>
        </ContentText>
      </CardContent>
      <CardContent sx={{ height: '15vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ReCAPTCHA hl="en" sitekey={process.env.REACT_APP_CAPTCHAR_SITE_KEY} onChange={onCaptcharChange} onExpired={onCaptcharExpired} />     
      </CardContent>
      <Divider light sx={{ width: '100%'}} /> 
      <CardActions sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', justifyContent: 'space-between' }}> 
        <Button width="140px" onClick={onGoToLogin} >Go to Login</Button>
        <Button width="140px" variant="contained" onClick={onConfirm} disabled={!captChar || !requestUser}>Send Request</Button>
      </CardActions>
    </Card>
    <LoadingOverlay visible={isLoading}/>  
  </Background>, [app, requestUser, captChar, isLoading])     

  return ( renderBackground )
}

export default Request